import Vue from 'vue';
import Vuex from 'vuex';
import { mapState, mapGetters } from 'vuex';


const waterSplashesFilter = Vue.component('water-splashes-filter', {
    template: `
    <button v-if="getWaterSplashes.Text" class="icon-filter" v-bind:class="{ active: isActive }" data-filter="WaterSplashes" @click="addFilter" :aria-pressed="isPressed">
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
              <path d="M31 27.848c0 3.793-3.137 6.862-7 6.862s-7-3.069-7-6.862c0-3.743 2.517-8.9 5.846-13.936.254-.389.689-.622 1.154-.622s.9.233 1.151.618C28.483 18.948 31 24.105 31 27.848zm-1.349 0c0-3.375-2.446-8.388-5.627-13.199-.003-.005-.012-.009-.023-.009a.032.032 0 00-.026.013c-3.179 4.807-5.625 9.82-5.625 13.195 0 3.041 2.527 5.513 5.651 5.513s5.65-2.472 5.65-5.513zM24 30.613a.675.675 0 110 1.35 4.23 4.23 0 01-2.958-1.2 4.077 4.077 0 01-1.231-2.915.675.675 0 011.349.001c-.001.73.296 1.431.826 1.95.533.52 1.257.814 2.014.814z"/>
              <circle fill="none" stroke="currentColor" stroke-miterlimit="10" cx="24" cy="24" r="23.5" class="hands-off" />
            </svg>
        </span>
        <div class="icon-text">
            {{getWaterSplashes.Text}}
        </div>
    </button>`,
    data: function () {
        return {
            isActive: false
        }
    },
    methods: {
        addFilter(e) {
            this.$store.commit('filters/toggleActiveFilters', this.$el.dataset.filter);
            this.toggleActive();
            this.$store.dispatch('filterAttractions');
        },
        toggleActive() {
            if (this.$store.state.filters.activeFilters.includes(this.$el.dataset.filter)) {
                this.isActive = true;
            } else {
                this.isActive = false;
            }
        }
    },
    computed: {
        ...mapGetters('filters', ['getWaterSplashes']),
        isPressed() {
            return this.isActive.toString();
        }
    },
    mounted() {
        this.toggleActive();
    }
});

export { waterSplashesFilter }